<template>
	<header class="my-header" :style="{backgroundColor:myBackgroundColor}">
		<div class="head-wrap">
			<div v-if="backFlag" class="left" @click="goBack()">
				<i class="iconfont iconfangxiangzuoN"></i>
				<!-- <i class="iconfont icondouble_right" v-if="!login"></i> -->
			</div>
			<!-- <div class="left"
           v-else>
        <slot name="left"></slot>
      </div> -->
			<div class="title">{{ headTitle }}</div>
		</div>
	</header>
</template>
<script>
	import {
		Tool
	} from '@/utils/Tool';
	export default {
		name: "myheader",
		data() {
			return {}
		},
		props: {
			// 页面标题，默认为空
			headTitle: {
				type: String,
				default: ""
			},
			myBackgroundColor: {
				type: String,
				default: "#0277FC"
			},
			// 是否隐藏返回按钮，默认显示
			backFlag: {
				type: Boolean,
				default: true
			},
			//调用回调函数，返回页面处理
			backIntercept: {
				type: Boolean,
				default: false
			},
		},
		methods: {
			// 返回
			goBack() {
				if (this.backIntercept) {
					this.$emit('childBackEvent', '')
				} else {
					this.$router.go(-1);
				}
				/*if (this.goWorkbench) {
				  // Tool.goWorkbench();
				  // 返回工作台
				  window.location.href = 'http://toworkbench.app.sinopec.com';
				  // this.$router.go(-1);
				  return;
				}else if(this.urlItem){
				   this.$router.push(
				          {
				              path:this.urlItem.path,
				              query:{
				                  id:this.urlItem.id,
				                  title:this.urlItem.title,
				              }
				          }
				      )
				}else{
				  this.$router.go(-1);
				}*/
			}
		}
	};
</script>
<style scoped lang="scss">
	.my-header {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 9;
		overflow: hidden;
		font-size: 14px;
		box-sizing: border-box;
		color: #fff;
		// background-color: #0277FC;
		padding-top: 1.8rem;

		.head-wrap {
			position: relative;
			width: 100%;
			height: 2.2rem;
			line-height: 2.2rem;
		}

		.left {
			position: absolute;
			top: 0;
			left: 0;

			.iconfont {
				padding: 0 0.5rem;
				font-size: 1.2rem;
			}
		}

		.right {
			position: absolute;
			right: 0.5rem;
			top: 1.8rem;
			display: flex;

			.iconfont {
				padding: 0.7rem 0.4rem;
				font-size: 1rem;
			}
		}

		.title {
			font-size: 16px;
			text-align: center;
			font-weight: 600;
			padding: 0 2rem;
		}
	}
</style>